import { StreamingObservations } from 'app/shared/streaming-observations';
import * as moment from 'moment'

// This connects and manages the incoming web data. It is responsible for polling the web service
// and buffering the incoming buffered data.
// There are multiple buffers that are effectively a circular buffer; we will stop requesting
// new data if the tail reaches the head of the buffer list. In normal usage it is unlikely that this
// will ever happen as there is a 30second window (in the API) for readings to be considered so the only
// way the ciculr buffer will become exhausted is when the plot loop doesn't execute (for some reason)
class ApiDataInterface {
    provider: any;
    elementId: number;
    data_idx: number;
    max_buffers: number;
    current_buffer: number;
    readinto_buffer: number;
    bufferedData: StreamingObservations ;
    data_buffers: StreamingObservations [];
    nextPollTime: number;
    pollInterval : number = 1000;
    read_id: number;
    lastStreamTimeStamp: Date;
    fetching_data: boolean;

    constructor(provider) {
        this.provider = provider;
        this.Reset();
    }
    Reset() {
        this.max_buffers = 3;
        this.current_buffer = -1;
        this.readinto_buffer = 0;
        this.data_buffers = [];
        for (var idx = 0; idx < this.max_buffers; idx++)
            this.data_buffers.push(null);
        this.data_idx = 0;
        this.bufferedData = null;
        this.data_idx = 0;
        this.lastStreamTimeStamp = null;
        this.fetching_data = false;
        this.read_id = 0;
        this.nextPollTime = null;
    }
    getBufferStorageLocation(buffer_index) {
        return buffer_index % this.max_buffers;
    }

    pollWebService(incidentId) {
        //
        // if no transfer is in process then we can see if it is time to
        // request from the server and upon response fill the next available data buffer.
        if (!this.fetching_data) {
            var now = Date.now();
            // see if there is any data that we should be pulling down.
            //var now = DateTime.Now.Ticks / TimeSpan.TicksPerMillisecond;
            if (this.nextPollTime == null || now > this.nextPollTime) {
                this.nextPollTime = Date.now() + this.pollInterval;

                if (this.getBufferStorageLocation(this.readinto_buffer) == this.getBufferStorageLocation(this.current_buffer))
                {
                    this.nextPollTime = now + 7000;
                    console.log("Buffers full; waiting ", this.readinto_buffer, " -> ", this.current_buffer);
                }
                else {
                    this.fetching_data = true;

                    this.provider.GetStreamingDataForIncident(incidentId, this.lastStreamTimeStamp)
                        .finally(
                            () => {
                                this.fetching_data = false;
                            })
                        .subscribe(
                            (res: StreamingObservations) => {
                                if (res.Observations.length) {
                                    var output_idx = this.getBufferStorageLocation(this.readinto_buffer++);
                                    if (res.EndTimeStamp != null && res.StartTimeStamp != null){
                                        this.pollInterval = Math.min(4000, ((res.EndTimeStamp.getTime() - res.StartTimeStamp.getTime()) / 3.0));
                                    }
                                    this.nextPollTime = Date.now() + this.pollInterval;
                                    console.log("__> interval ",this.pollInterval,":: next poll ",new Date(this.nextPollTime));

                                    this.data_buffers[output_idx] = res;
                                    if (res.EndTimeStamp != null)
                                        this.lastStreamTimeStamp = res.EndTimeStamp;
                                }
                                else{
                                    this.pollInterval = 1000;
                                    this.nextPollTime = Date.now() + this.pollInterval;
                                    console.log("NO DATA interval ",this.pollInterval,":  next poll ",new Date(this.nextPollTime));
                                }
                            });
                }
            }
        }
    }

    getData(incidentId) {
        //
        // the current buffer is stored in bufferedData; so if we have this then we can iterate through it
        // until it runs out.
        // we do this in two passes as the bufferedData may valid but exhasuted - so to make the
        // code orthogonal we handle the case where there is data at the beginning; even though this
        // data may actually have run out and require more data.
        for (var pass = 0; pass < 2; pass++) {
            if (this.bufferedData != null) {
                if (this.data_idx < this.bufferedData.Observations.length) {
                    var rv = this.bufferedData;
                    this.bufferedData = null;
                    return rv;
                }
                this.bufferedData = null;
            }

            // if null then out of data so see if there is another buffer ready, if so this will be picked up by the second pass of the loop
            if (this.bufferedData == null) {

                // get next buffer if there is one ready
                if (this.current_buffer+1 < this.readinto_buffer) {
                    var nextbuffer = this.getBufferStorageLocation(++this.current_buffer);
                    this.bufferedData = this.data_buffers[nextbuffer];
                    this.data_idx = 0;
                }
            }
        }
        // indicates no data available.
        return null;
    }
}


///
/// this interfaces between the plots and the underlying data interface.
/// there is one of these for each pair of plot lines; in the tablet app there
/// is one instance for each plot line; this is because we are getting a data packet
/// from the server that contains both the SPO2 and ECG data.
class DeviceDataInterface {
    provider: any;
    elementId: number;
    IncidentId: any;
    data_idx: number;
    bufferedData: StreamingObservations;
    dateOffset: number;
    currentDelta : number = null;
    lastTime:number=null;
    laggedDelta: number = 0;
    currentStart : number = null;
    dataStartTime: Date;
    constructor(provider, incidentId) {
        this.provider = provider;
        this.bufferedData = null;
        this.data_idx = 0;
        this.dateOffset = null;
        this.IncidentId = incidentId;
    }

    nextItem() {
        if (this.bufferedData != null) {
            this.data_idx++;
            return this.data_idx >= this.bufferedData.Observations.length;
        }
        return 1; // no data;
    }

    getSweepDate() {
        if (this.bufferedData && this.data_idx < this.bufferedData.Observations.length) {
            return this.dataStartTime;
        }
        else
            return null;
    }
    
    getPlotRelativeTime(date: Date) {
        return date.getTime() + this.dateOffset;
    }
    exponentialLagCompensator(lagv, unlagged, dt, tau)
	{
//        console.log("calc(",lagv,", ",unlagged,", ",dt,", ",tau,");");
		return Math.exp(-dt / tau) * (lagv - unlagged) + unlagged;
	}
    getNextBlock() {
        this.bufferedData = this.provider.getData(this.IncidentId); 
        if (this.bufferedData != null) {
            this.dataStartTime = this.bufferedData.StartTimeStamp;
            var d = new Date();
            var now = new Date(d.getTime() - ((d.getTimezoneOffset() * 60000)));

            if (this.dataStartTime != null)
                this.dateOffset = now.getTime() - this.bufferedData.StartTimeStamp.getTime();
            else
                this.dateOffset = 0;

            // the way this works is to record the first date offset and use this as the baseline
            // to try and keep the drift to this value using a Lag
            
            if (this.currentStart == null)
                this.currentStart = this.dateOffset;

            // to work out the amount of lag we need to know the dT between the last point and the current point
            // and then we can use the calculated dateOffset (adjusted by the currentStart)
            if (this.lastTime != null) {
                var dt = Date.now() - this.lastTime;
                this.currentDelta = this.dateOffset - this.currentStart;

                // the lag value TAU of 75000 is based on experimentation; it is a time value in seconds and 
                // is relative to the values of dt
                this.laggedDelta = this.exponentialLagCompensator(this.laggedDelta, this.currentDelta, dt, 75000);

console.log("offset = ", this.dateOffset, " delta=", this.currentDelta, " start = ", this.currentStart, " lagged=", this.laggedDelta, " dt=", dt);
            }
            this.lastTime = Date.now();
        }
        else
        {
            this.laggedDelta = 0;
            this.lastTime = null;
            this.currentDelta = null;
            this.currentStart = null;
        }
        this.data_idx = 0;
    }
    // this method is used to discard data to account for the drift based 
    // on the laggedDelta in the provider.
    // The method is called when the plot rests and discards based readings
    // based on their time.
    // the reurn value is the amount of drift adjusted for in seconds.
    compensateForDrift(name)
    {
        // only do this if we have buffered data.
        if (this.bufferedData != null) {
            if (this.data_idx < this.bufferedData.Observations.length) {

                // work out the end point by taking the current date and adding the
                // delta Lag (in seconds)
                var currentObservation = this.bufferedData.Observations[this.data_idx];
                var adjustTo = this.laggedDelta + currentObservation.ObservationDate.getTime();

                var si = this.data_idx;
                var startTime=Date.now();
//console.log("compensate drift started",adjustTo, " for ",name);
                while(this.data_idx < this.bufferedData.Observations.length)
                {
                    if (this.bufferedData.Observations[this.data_idx].ObservationDate.getTime() >= adjustTo){
                        var drift =  this.bufferedData.Observations[this.data_idx].ObservationDate.getTime()-currentObservation.ObservationDate.getTime();;
//console.log("   -- adjusted skip= ",this.data_idx-si, " d=",drift, " time=",Date.now() - startTime," ms");
                        return drift;
                    }
                    this.data_idx++;
                    this.getData();
                    // could now be out of data.
                    if (this.bufferedData == null)
                        return 0;
                }
//console.log("   -- failed took=",Date.now() - startTime," ms");
            }
        }
        return 0;
    }
    Reset(){
        this.bufferedData = null;
        this.data_idx = 0;
        this.dateOffset = null;
        this.provider.Reset();
        this.currentDelta = null;
        this.lastTime = null;
        this.laggedDelta = 0;
        this.currentStart = null;
        this.dataStartTime=null;
    }
    // get the data for the plot.
    // this uses the current buffer (block) from the data interface and will attempt to get a new
    // block when the current block is set to null.
    getData() {
        if (this.bufferedData == null) {
            this.getNextBlock();
        }
        if (this.bufferedData != null && this.data_idx >= this.bufferedData.Observations.length)
            this.getNextBlock();

        if (this.bufferedData != null) {
            if (this.data_idx < this.bufferedData.Observations.length) {
                var rv = this.bufferedData.Observations[this.data_idx];

                if (rv != null) {
                    this.dataStartTime = rv.ObservationDate;
                }
                else
                    this.dataStartTime = null;
                return rv;
            }
            else {
                this.getNextBlock();
            }
        }
        return null;
    }

    ClearStream() {
        
    }
}

// This is responsible for a single streaming plot; either ECG or SPO2.
class PlotLine {
    ctx: any;
    dataProvider: any;
    frameStart: any;
    h: number;
    hScalePixelsPerSecond: number;
    lastUpdate: any;
    px: number;
    py: number = null;
    scanBarWidth: number;
    w: number;
    plotField: string;
    plotDrawFrequency_ms: number = 20.0; // the plot will be updated at screen referesh; usually 60hz; which is 16.66ms

    ecg: boolean = false;
    startTime: Date;
    xScale_ms: number;
    relatedPlots: any;
    lastDataPlotted: Date;
    deviceOnline: boolean = false;
    name: string;
    no_data_count: number = 0;
    plot_suspended: boolean = false;

    constructor(name, context, w, h, dataProvider, ecg = false) {
        this.ctx = context;
        this.ctx.lineWidth = 3;
        this.ctx.strokeStyle = '#00bd00';
        this.name = name;
        this.dataProvider = dataProvider;
        this.frameStart = null;
        this.lastUpdate = null;
        this.px = null;
        this.py = null;
        this.scanBarWidth = 20;
        this.w = w;
        this.h = h;
        this.xScale_ms = 10000.0;
        this.hScalePixelsPerSecond = this.w / (this.xScale_ms / 1000.0);
        this.ecg = ecg;
        this.startTime = null;
        this.lastDataPlotted = now;
        this.relatedPlots = [];
        this.deviceOnline = false;
        this.lastDataPlotted = null;
    }
    // called when the plot reaches the end. This will reset any related plots
    // to keep the plots vaguely in sync; i.e. during the plot the two plots
    // will be free running based on the data returned. 
    resetPlot() {

        // firstly if there is a valid start time then adjust 
        // for drift.
        if (this.startTime != null) {
            var drift = this.dataProvider.compensateForDrift(this.name);
            this.lastUpdate = null;
        }

        this.startTime = null;
        this.ctx.fillStyle = "#f0f";
        if (this.px != null) {
            // only erase the end section if it won't be erased shortly.
            if (this.px > w / 7.0) {
                this.ctx.clearRect(this.px, -this.h, this.w, this.h * 2);
            }
        }
        this.ctx.clearRect(-1, -this.h, this.scanBarWidth, this.h * 2);
        this.px = 0;
        this.py = null;
        if (this.deviceOnline) {
            for (var i = 0; i < this.relatedPlots.length; i++) {
                this.relatedPlots[i].resetPlot();
            }
        }
    }
    addRelatedPlot(plot) {
        this.relatedPlots.push(plot);
    }
    // determine if the plot should be updated; this is to allow the plot to be drawn
    // at a specific rate (in mS)
    readyToPlot(now) {

        if (this.lastUpdate == null)
            return true;

        var deltaT = Math.abs(now.getTime() - this.lastUpdate);
        if (deltaT > this.plotDrawFrequency_ms)
            return true;
        return false;
    }

    //
    // plot the collected streaming data.
    // - reasonably simple as we rely on the date in the reading (not deltaT) and
    //   thus providing that the device interface provides reliable observation
    //   date interpolation the plot will just work.
    plotCollected(now, reset, dataField, endDt, endpx,) {
        var rv = false;
        var opx = null;
        var opy = null;

        if (reset) {
            this.resetPlot();
            rv = true;
        }
        var d = this.dataProvider.getData();

        //
        // as the data rates of plots do not necessarily line up this detects when there is a significant
        // lack of data compared with a few missing values.
        // When there is significant missing data we will suspend this plot (orange) and only turn it back on again
        // when we get some data. The logic is that a single point will reactivate the plot when the device comes back online.
        if (d !== null) {
            if (d[dataField] === null) {
                if (this.no_data_count++ > 30) {
                    this.plot_suspended = true;
                    this.deviceOnline = false;
                }
                else return;
            }
            else {
                if (this.plot_suspended){
                    this.dataProvider.Reset();
                    this.resetPlot();
                    rv = true;
                }
                this.no_data_count = 0;
                this.plot_suspended = false;
            }
        }

        if (d === null || this.plot_suspended) {
            if (this.lastDataPlotted === null)
                this.lastDataPlotted = now;
            else {
                if (now.getTime() - this.lastDataPlotted.getTime() > 10000) {
                    d = {
                        ObservationDate: this.lastDataPlotted,
                        Plt: 0,
                        I: 0,
                        II: 0,
                        III: 0
                    };
                    this.lastDataPlotted = new Date(this.lastDataPlotted.getTime() + this.plotDrawFrequency_ms);
                    this.deviceOnline = false;
                }
            }
        }
        else {
            this.lastDataPlotted = now;
            this.deviceOnline = true;
        }
        if (d === null) {
            return true;
        }
        // record the start time (to calculate deltas) at the start of the plot
        if (this.startTime === null) {
            this.startTime = d.ObservationDate;
        }
        var dT = d.ObservationDate.getTime() - this.startTime.getTime();

        // if no more space then simply reset the plot and in this case we can also
        // safely assume that the time offset will be zero
        if (dT >= this.xScale_ms) {
            this.resetPlot();
            dT = 0;
            return true;
        }
        opx = this.px;
        // if the plot has been reset then also reset Y to avoid strange line artefacts at the start when wrapping.
        if (this.py == null)
            opy = scale(d[dataField], this.h);
        else
            opy = this.py;

        this.px = (dT / 1000.0) * this.hScalePixelsPerSecond;
        this.py = scale(d[dataField], this.h);

        this.ctx.clearRect(opx + 1, -this.h, (this.px - opx) + this.scanBarWidth, this.h * 2);

        if (this.deviceOnline && !this.plot_suspended)
            this.ctx.strokeStyle = '#00bd00';
        else
            this.ctx.strokeStyle = '#ffb50a';

        this.ctx.beginPath();
        this.ctx.moveTo(opx, opy);
        this.ctx.lineTo(this.px, this.py);
        this.ctx.stroke();
        this.lastUpdate = now.getTime();
        return rv;
    }

    ClearStream() {
        this.dataProvider.ClearStream();
    }
};

var context = null, w = 0, h = 150;
var context2 = null, w2 = 0, h2 = 150;

var now:Date;
var i, j, k;

var spo2_started = false;
var ecg_started = false;

var spo2Plot: PlotLine  = null;
var ecgPlot: PlotLine  = null;


function scale(num = 0, height) {
    num = num || 0;
    return -(num * (height / 2));
}

import { Component, OnInit, ElementRef, ViewChild, NgZone } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs/Subscription";

import { CaseService } from "app/case/case.service";
import { Incident, Observation } from "app/shared/shared.module";
import { Observable } from "rxjs/Rx";
import { ModalDirective } from "ngx-bootstrap";
import { Param } from 'app/brightserve/brightserve.module';

@Component({
	selector: 'app-case-details-monitoring',
	templateUrl: './case-details-monitoring.component.html',
    styleUrls: ['./case-details-monitoring.component.css'],
    providers: [DatePipe]
})
export class CaseDetailsMonitoringComponent implements OnInit {

    @ViewChild('ECGModal') public ECGModal: ModalDirective;

    @ViewChild('ecgCanvas') ecgCanvas: ElementRef;
    @ViewChild('spo2Canvas') spo2Canvas: ElementRef;

    SelectedDate: any = null;
    ECG12LeadLoaded: boolean = false;
    ECGSubscription: Subscription;

    Incident: Incident;
    IncidentId: any;
	LeadSelector: string = "II";

    RefreshTime: Date = new Date();

    ECGValue = 1;
    RequestId = null;

    MonitoringDevices: any[] = [
        { Colour: "black",            Title: "Pulse Rate",          Type: "SPO2",                Data1: "PulseO2",         Data2: "PulseRate", Icon: "flaticon-stethoscope",       Unit: "BPM",      Sources: ["SPO2.2"],                             Observation: {}, SDKType: 2,    DecimalPlaces: 0 }, //"BloodPressure.4"
        { Colour: "bg-purple-seance", Title: "Respiratory Rate",    Type: "RespiratoryRate",     Data1: "RespiratoryRate",                     Icon: "flaticon-lungs",             Unit: "/min",     Sources: ["RespiratoryRate.1"],                  Observation: {}, SDKType: null, DecimalPlaces: 0 },
        { Colour: "light-blue",       Title: "Pulse O<sub>2</sub>", Type: "SPO2",                Data1: "PulseO2",         Data2: "PulseRate", Icon: "flaticon-cardiogram-1",      Unit: "%",        Sources: ["SPO2.1"],                             Observation: {}, SDKType: 2,    DecimalPlaces: 0 },
        { Colour: "bg-yellow-crusta", Title: "Blood Pressure",      Type: "BloodPressure",       Data1: "Systolic",        Data2: "Diastolic", Icon: "flaticon-sphygmomanometer",  Unit: "mmHg",     Sources: ["BloodPressure.1", "BloodPressure.2"], Observation: {}, SDKType: 4,    DecimalPlaces: 0 },
        { Colour: "bg-red-mint",      Title: "Temperature",         Type: "Temperature",         Data1: "Temperature",                         Icon: "flaticon-thermometer",       Unit: "&#8451;",  Sources: ["Temperature.1"],                      Observation: {}, SDKType: 5,    DecimalPlaces: 1 },
        { Colour: "bg-orange",        Title: "Peak Flow",           Type: "PeakFlow",            Data1: "FEV1",            Data2: "PeakFlow",  Icon: "flaticon-exercise",          Unit: "L/min",    Sources: ["PeakFlow.2"],                         Observation: {}, SDKType: 7,    DecimalPlaces: 0 },
        { Colour: "bg-orange",        Title: "FEV1",                Type: "PeakFlow",            Data1: "FEV1",            Data2: "PeakFlow",  Icon: "flaticon-exercise",          Unit: "L",        Sources: ["PeakFlow.1"],                         Observation: {}, SDKType: 7,    DecimalPlaces: 2 },
        { Colour: "bg-blue-steel",    Title: "Blood Sugar",         Type: "BloodGlucose Gen",    Data1: "BloodSugar",                          Icon: "flaticon-sugar-blood-level", Unit: "mmol/L",   Sources: ["BloodGlucose Gen.1"],                 Observation: {}, SDKType: 3,    DecimalPlaces: 1 },
        { Colour: "dark-red",         Title: "Haematocrit",         Type: "BloodGlucose HCT",    Data1: "Haematocrit",                         Icon: "flaticon-red-blood-cells",   Unit: "%",        Sources: ["BloodGlucose HCT.1"],                 Observation: {}, SDKType: 3,    DecimalPlaces: 0 },
        { Colour: "bg-grey-cascade",  Title: "Ketone",              Type: "BloodGlucose Ketone", Data1: "Ketone",                              Icon: "flaticon-pancreas",          Unit: "mmol/L",   Sources: ["BloodGlucose Ketone.1"],              Observation: {}, SDKType: 3,    DecimalPlaces: 1 },
        { Colour: "bg-purple-soft",   Title: "GCS",                 Type: "GlasgowComaScale",    Data1: "GlasgowComaScale",                    Icon: "flaticon-brain",             Unit: "GCS",      Sources: ["GlasgowComaScale.1"],                 Observation: {}, SDKType: null, DecimalPlaces: 0 },
    ];
    Observations: Observation[] = [];

    sub: Subscription;
    TenSecondIntervalSubscription: Subscription;
    StreamedObservationsIntervalSubscription: Subscription;
    GetIncidentDetailsSubscription: Subscription;
    GettingECGImages: Subscription;

    ChartsStopped = false;

    LastTime: Date;
    LastDisplayed: Date = null;
    LastSweepTime: Date = null;
    plotLagTimeSeconds : number = 0;

    LastSweepTimeDisplay: Date = null;
    apiDataService: ApiDataInterface = null;
    dataProvider: DeviceDataInterface = null;
    LastStreamTimeStamp: Date = null;
    out_of_data: boolean = false;
    HistoricECGGroups: any[] = [];
    HistoricECGImages: string[] = [];

    constructor(private caseService: CaseService, private route: ActivatedRoute, public ngZone: NgZone) { }

    ngOnInit() {
        this.sub = this.route.parent.params.subscribe(params => {
            if (params && params['id']) {
                this.IncidentId = params['id'];
                this.GetIncidentDetailsSubscription = this.GetObservations();

            };
        });
        this.apiDataService = new ApiDataInterface(this.caseService);
        this.dataProvider = new DeviceDataInterface(this.apiDataService, this.IncidentId);
        this.ECGValue = 1;
        this.ECGCanvasInit();
        this.SPO2CanvasInit();
        this.StartCharts();
    };
    ngOnDestroy() {
        this.StopCharts();

        this.sub.unsubscribe();
        this.TenSecondIntervalSubscription.unsubscribe();
        this.GetIncidentDetailsSubscription.unsubscribe();
    }

    ECGCanvasInit() {
        context = (<HTMLCanvasElement>this.ecgCanvas.nativeElement).getContext('2d');
        w = (<HTMLCanvasElement>this.ecgCanvas.nativeElement).width;
        h = (<HTMLCanvasElement>this.ecgCanvas.nativeElement).height;
        context.strokeStyle = '#00bd00';
        context.lineWidth = 3;
        context.translate(0, h / 2);

        ecgPlot = new PlotLine("ECG", context, w, h, this.dataProvider, true);
    };
    SPO2CanvasInit() {

        context2 = (<HTMLCanvasElement>this.spo2Canvas.nativeElement).getContext('2d');
        w2 = (<HTMLCanvasElement>this.spo2Canvas.nativeElement).width;
        h2 = (<HTMLCanvasElement>this.spo2Canvas.nativeElement).height;
        context2.strokeStyle = '#00bd00';
        context2.lineWidth = 3;
        context2.translate(0, h2 / 2);

        spo2Plot = new PlotLine("SO2", context2, w2, h2, this.dataProvider);
        ecgPlot.addRelatedPlot(spo2Plot);

    };

    StartCharts() {
        this.ChartsStopped = false;
        this.LastTime = new Date();
        if (this.RequestId != null) {
            cancelAnimationFrame(this.RequestId);
            this.RequestId = null;
        }
        this.ngZone.runOutsideAngular(() => {
            requestAnimationFrame(() => {
                this.RequestId = requestAnimationFrame(this.loop.bind(this));
            });
        });
    }

    StopCharts() {
        this.ChartsStopped = true;
        if (this.RequestId != null) {
            // Turn of the animation and data collection for the charts
            cancelAnimationFrame(this.RequestId);
            this.RequestId = null;
        }
    };

    getECGField(id) {
        switch (id) {
            default:
            case 0: return "I";
            case 1: return "II";
            case 2: return "III";
        }
    };

    loop() {
        if (this.ChartsStopped)
            return;

        // Add a try catch into this loop to try and prevent tablet app from crashing
        try {

            this.apiDataService.pollWebService(this.IncidentId);

            var now = new Date();
            if (this.LastTime === null)
                this.LastTime = now;

            var resetPlot = false;
            if (ecgPlot.readyToPlot(now)) {
                var iterations = ecgPlot.plotDrawFrequency_ms;
                while (iterations-- > 0) {
                    var d = this.dataProvider.getData();
                    //
                    // if there isn't a data point then mark that we are out of data
                    // this is used when data arrives to help determine if the plot needs to be
                    // reset
                    if (d === null) {
                        this.out_of_data = true;
                        this.plotLagTimeSeconds = 0;
                    }

                    //
                    // if not ready to plot then don't
                    // - what we do is when the data arrives we figure out the offset between the data and now and use
                    //   this to drip feed the block of data onto the display 
                    if (d != null && this.dataProvider.getPlotRelativeTime(d.ObservationDate) > now.getTime())
                        break;

                    // when data becomes available after a pause we will see if we need to reset the plot.
                    if (d != null && this.out_of_data) {
                        this.out_of_data = false;
                        // see if the time gap between the plots is more than a significant amount and if it is then reset the plot
                        // back to the start - otherwise just continue.
                        if (!(ecgPlot.deviceOnline || spo2Plot.deviceOnline)
                            || (this.LastSweepTime != null && this.dataProvider.getSweepDate()
                                && Math.abs(this.LastSweepTime.getTime() - this.dataProvider.getSweepDate().getTime()) > 100)) {
                            resetPlot = true;
                            this.plotLagTimeSeconds = 0;
                        }
                    }

                    // plot the data ; note that when either device is online the other device plot will not do anything.
                    // this is because we can't differentiate between null values that are there because there isn't a matching
                    // data point (when the ECG is online) as the data rate of the two devices are dissimilar.
                    var done = spo2Plot.plotCollected(now, resetPlot,  "Plt", null, ecgPlot.px);
                    done = ecgPlot.plotCollected(now, resetPlot, this.getECGField(this.ECGValue), null, null) || done;

                    this.LastSweepTime = this.dataProvider.getSweepDate();
                    if (this.LastSweepTime != null) {
                        this.LastSweepTimeDisplay = new Date(this.LastSweepTime.getTime() - (this.LastSweepTime.getTimezoneOffset() * 60000));
                        this.plotLagTimeSeconds = (Date.now() -  this.LastSweepTimeDisplay.getTime())/1000.0;
                        if (this.plotLagTimeSeconds > 50){
                            console.log("Reset plot because plot lag excessive ",this.plotLagTimeSeconds);
                            this.ResetPlots();
                        }
                    }
                    if (done || spo2_started || ecg_started || this.dataProvider.nextItem()) {
                        this.LastTime = now;
                    }
                }
            }
            
            this.RequestId = requestAnimationFrame(this.loop.bind(this));
        }
        catch (e) {
            // Error has occurred
            console.log(e);
            if (this.RequestId != null) {
                cancelAnimationFrame(this.RequestId);
                this.RequestId = null;
            }
        }
    }

    OpenECGModal() {
        this.ChartsStopped = true;
        this.ECGModal.show();
        // Turn of the animation and data collection for the charts
        if (this.RequestId != null) {
            cancelAnimationFrame(this.RequestId);
            this.RequestId = null;
        }
        this.SelectedDate = null;
        this.ECG12LeadLoaded = false;
        this.GetHistoric12ECGGroups();
    };

    CloseECGModal() {
        this.ECGModal.hide();
    };
    ResetPlots() : any {
        this.dataProvider.Reset();
    }
    GetObservations(): any {
        if (this.TenSecondIntervalSubscription)
            this.TenSecondIntervalSubscription.unsubscribe();
        // EMIT EVERY 10 SECONDS
        this.TenSecondIntervalSubscription = Observable.timer(10000, 10000).subscribe(x => {
            this.GetObservations();
        });

        return this.caseService.GetCaseDetails(this.IncidentId).subscribe(
            incident => {
                this.Incident = incident;
                this.Observations = incident.Observations;
                this.MonitoringDevices.forEach((item) => {
                    item.Observation = this.ExtractDisplayData(item);
                });
                this.RefreshTime = new Date();               

            }, err => {
                console.log(err);
            });

    };

    ExtractDisplayData(device): any {
        var types = [];
        var result = { ManualEntry: true, ObservationDate: null, data: [], _observation: {} };

        if (device.Sources && device.Sources.length) {
            device.Sources.forEach((_source) => {
                types.push(_source.substring(0, _source.indexOf('.')));
            });
            var matches = this.Observations.filter(function (xx) {
                return types.indexOf(xx.Type.Value) > -1
            });
            
            if (matches.length) {

                var match = matches[matches.length - 1];
                result.ManualEntry = match.ManualEntry;
                result.ObservationDate = match.ObservationDate;
                result._observation = match;

                var indexes = [];
                device.Sources.forEach((_source) => {
                    if (_source.indexOf(match.Type.Value) != -1)
                        indexes.push(parseInt(_source.substring(_source.indexOf('.') + 1)));
                });
                indexes = indexes.sort();
                result.data = [];
                indexes.forEach((_index) => {
                    result.data.push(match['Value' + _index]);
                });
            }
        }
        return result;
    };

    SelectLead(Lead: string = 'I') {
        switch (Lead) {
            case 'I':
                this.ECGValue = 0;
                break;
            case 'II':
                this.ECGValue = 1;
                break;
            case 'III':
                this.ECGValue = 2;
                break;
            default:
                this.ECGValue = 1;
                break;
        }
    };

    SelectDate(item) {
        this.SelectedDate = item;
        this.ECG12LeadLoaded = false;
        this.caseService.GetObservationGroupObservations(item.ObservationGroupId).subscribe((res) => {
            var ecgData = res.Observations;
            this.Generate12ECGImages();
        });
    };

    GetHistoric12ECGGroups() {
        this.HistoricECGGroups = [];
        this.caseService.GetObservationsGroupsForIncident(this.IncidentId, new Param({ Entity: "Observation", Field: "Type", Value: "ECG12" })).subscribe((res) => {
            console.log(res);
            this.HistoricECGGroups = res.ObservationGroups;
        });
    }

    Generate12ECGImages() {
        this.HistoricECGImages = [];
        this.GettingECGImages = this.caseService.Generate12ECGImagesForIncident(this.IncidentId, this.SelectedDate.ObservationGroupId).subscribe((res) => {
            console.log(res);
            this.ECG12LeadLoaded = true;
            this.HistoricECGImages = res.Images;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/case/details/monitoring/case-details-monitoring.component.ts